import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';

import { ModelOfEspecie } from 'src/database';
import LoadingScreen from '../../components/LoadingScreen';

import { useListEspecieController } from '../../controllers/Especies/ListEspecieController';
import { Toast } from 'primereact/toast';

const EspecieList: React.FC = () => {
    const { getEspecieListController, handleEspecieListController } = useListEspecieController();

    if (getEspecieListController.loading) {
        return <LoadingScreen />
    };

    const actionBodyTemplate = (Especie: ModelOfEspecie) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-success p-mr-2" onClick={() => handleEspecieListController.openEditDialog(Especie)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger" onClick={() => handleEspecieListController.openDeleteDialog(Especie)} />
            </React.Fragment>
        );
    };

    const editEspecieDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={handleEspecieListController.closeEditDialog} />
            <Button type="submit" label="Salvar" icon="pi pi-check" className="p-button-text" onClick={() => { getEspecieListController.formik.handleSubmit() }} />
        </React.Fragment>
    );

    const deleteEspecieDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={handleEspecieListController.closeDeleteDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text"
                onClick={() => {
                    getEspecieListController.selectedEspecie && handleEspecieListController.removeEspecie(getEspecieListController.selectedEspecie)
                }}
            />
        </React.Fragment>
    );

    const leftEspecieToolbar = () => {
        return (
            <Link to="/EspecieForm">
                <Button label="Cadastrar espécie de veículo" icon="pi pi-plus" className="p-button-success p-mr-2" />
            </Link>
        );
    };

    return (
        <div>
            <Toast ref={getEspecieListController.toast} />
            <div className="p-card p-p-4 datatable-container">
                <Toolbar className="p-mb-4" left={leftEspecieToolbar}></Toolbar>

                <DataTable className="p-datatable-sm responsive-table"
                    dataKey="ID" autoLayout scrollHeight={'100%'}
                    scrollable rowHover
                    value={getEspecieListController.EspecieData}
                >
                    <Column field="DESCRICAO" header="ESPÉCIE"></Column>
                    <Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
                </DataTable>
            </div>

            <Dialog
                className="p-fluid dropdown-visible"
                style={{ width: '450px' }}
                visible={getEspecieListController.editDialog}
                onHide={handleEspecieListController.closeEditDialog}
                onShow={() => getEspecieListController.formik.setValues(getEspecieListController.selectedEspecie)}
                footer={editEspecieDialogFooter}
                header={`Editar espécie de veículo ${getEspecieListController.selectedEspecie?.DESCRICAO}`}
                modal
            >
                <div className="p-field p-col-12">
                    <label htmlFor="description">Descrição</label>
                    <InputText id="name" type="text"
                        value={getEspecieListController.formik.values.DESCRICAO}
                        onChange={getEspecieListController.formik.handleChange('DESCRICAO')}
                        required
                    />
                    <div className={classNames("p-invalid popup-fade", {
                        'popup-form-active': getEspecieListController.formik.touched.DESCRICAO && getEspecieListController.formik.errors.DESCRICAO,
                        'popup-form-inactive': !(getEspecieListController.formik.touched.DESCRICAO && getEspecieListController.formik.errors.DESCRICAO),
                    })}
                    >{getEspecieListController.formik.errors.DESCRICAO}</div>
                </div>
            </Dialog>

            <Dialog
                style={{ width: '450px' }}
                visible={getEspecieListController.deleteDialog}
                onHide={handleEspecieListController.closeDeleteDialog}
                footer={deleteEspecieDialogFooter}
                header="Remover espécie de veículo"
                modal
            >
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {getEspecieListController.selectedEspecie && <span>Você tem certeza que deseja remover a espécie de veículo <b>{getEspecieListController.selectedEspecie.DESCRICAO}</b>?</span>}
                </div>
            </Dialog>
        </div>

    );
};

export default EspecieList;